import React from "react";
import ProfileBanner from "../../shared/utilities/ProfileBanner";

const TransporterOwners = props => {
  const owners = props.owners.map((owner, i) => (
    <div key={i}>
      {i + 1}. {owner.TRANS_OWNER_NAME}
    </div>
  ));

  return <ProfileBanner title="Entity Members">{owners}</ProfileBanner>;
};

export default TransporterOwners;
